"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getOwaUserConfigurationOperation_1 = require("owa-service/lib/operation/getOwaUserConfigurationOperation");
/**
 * Gets the new time zone offsets by getting the user configuration
 */
function getNewTimeZoneOffsets() {
    return getOwaUserConfigurationOperation_1.default().then(function (userConfiguration) {
        return userConfiguration.UserOptions.MailboxTimeZoneOffset;
    });
}
exports.default = getNewTimeZoneOffsets;
//# sourceMappingURL=getNewTimeZoneOffsets.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/services/getNewTimeZoneOffsets.js
// module id = 4952
// module chunks = 2